import type { Step } from 'react-joyride'

const TourProgressBar = ({
  steps,
  currentStep,
}: {
  steps: Step[]
  currentStep: number
}) => {
  return (
    <div
      className="fixed top-0 left-0 right-0 z-[20001]"
      role="progressbar"
      aria-valuenow={currentStep}
      aria-valuemin={1}
      aria-valuemax={steps.length}
    >
      <div
        className="h-1 bg-primary transition-all duration-300 ease-out"
        style={{
          width: `${steps.length > 0 ? ((currentStep + 1) / steps.length) * 100 : 0}%`,
          height: '4px',
          background: '#1B144B',
          transition: 'width 0.3s',
        }}
      />
    </div>
  )
}

export default TourProgressBar
